import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'
import HeaderAvalingua from '../components/HeaderAvalingua'
import pic04 from '../assets/images/pic04.jpg'
import i18n from '../components/i18n'

class Avalingua extends React.Component {
  constructor(props) {
    super(props)
    i18n.changeLanguage('en')
  }
  render() {
    return (
      <Layout>
        <Helmet title="What is Avalingua?" />
        <HeaderAvalingua />
        <div id="main">
          <section id="content" className="main">
            <span className="image main">
              <img src={pic04} alt="" />
            </span>
            <h2>What is Avalingua?</h2>
            <p>
              Avalingua automatically evaluates the linguistic quality of texts,
              both in Galician and Spanish (the Portuguese version is in
              process). From a written text or a set of texts, Avalingua makes a
              detailed analysis using different natural language processing
              tools, including a syntactic dependency analyser, and various
              language resources. It has been developed by the Tecnoloxías da
              Linguaxe Natural program of CiTIUS, University of Santiago de
              Compostela, Galiza.
            </p>
            <h2>What advantages does this technology have?</h2>
            <p>
              It allows us to go beyond the usual grammar checkers, because it
              not only allows us to detect spelling and lexical errors, but
              also, thanks to an automatic syntactic analyzer, it identifies
              more complex grammatical problems between syntactically related
              words that are at a great distance from each other.
            </p>
            <h2>What research is Avalingua based on?</h2>
            <p>
              Avalingua is a set of PLN modules with hybrid technology,
              combining expert knowledge, heuristics, language resources and
              machine learning. The number of types of errors and linguistic
              problems that can be found in texts is so high that it is outside
              the scope of any classifier, as there are not enough training
              dates with sufficient diversity. For this purpose, we believe
              hybrid technology is needed that includes explicit expert
              knowledge. Syntactic knowledge is encoded with DepPattern
              technology, a dependency analyser compiled from grammars provided
              with an intuitive formalism for linguists.
            </p>
            <h2>What are the applications of Avalingua?</h2>
            <p>
              The most direct application is in the field of education, with two
              clear directions: it can be used as a monitoring and evaluation
              system for primary and secondary students, or/and as a second
              language self-learning tool for foreign students.
            </p>
          </section>
        </div>
      </Layout>
    )
  }
}

export default Avalingua
